import type { ButtonProps } from '@chakra-ui/react'
import { Button, Flex } from '@chakra-ui/react'
import type { MouseEvent } from 'react'
import { useState } from 'react'

interface ConfirmRemoveButtonProps extends ButtonProps {
  defaultLabel?: string
  hideCancelButton?: boolean
  fullWidth?: boolean
}

export const ConfirmRemoveButton = ({
  defaultLabel = 'Odebrat',
  hideCancelButton = false,
  fullWidth = true,
  onClick,
}: ConfirmRemoveButtonProps) => {
  const [confirm, setConfirm] = useState<boolean>(false)

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (!confirm) {
      setConfirm(true)
    } else {
      onClick?.(e)
    }
  }

  return (
    <Flex
      sx={{
        gap: 2,
        w: fullWidth ? '100%' : 'auto',
        justifyContent: confirm ? 'space-between' : 'start',
      }}
    >
      {!hideCancelButton && confirm && (
        <Button
          type="button"
          colorScheme={'gray'}
          // variant="ghost"
          onClick={() => setConfirm(false)}
        >
          Zrušit
        </Button>
      )}

      <Button
        type="button"
        colorScheme="red"
        variant='solid'
        size='md'
        // variant={confirm ? 'solid' : 'outline'}
        onClick={handleClick}
      >
        {confirm ? 'Opravdu odebrat?' : defaultLabel}
      </Button>
    </Flex>
  )
}
